import type { PromptFieldOptions, SchemaPromptContext } from '@cli-types/next-adapter/commands.js'

export const ADD_FIELD_PROMPT_CONTEXT: SchemaPromptContext = {
  cancelMessage: 'Add field cancelled.'
}
export const CREATE_PROMPT_CONTEXT: SchemaPromptContext = {
  cancelMessage: 'Create schema cancelled.'
}
export const CREATE_FIELD_PROMPT_OPTIONS: PromptFieldOptions = {
  deriveName: true,
  derivePlaceholder: true,
  promptAdvancedOptions: false,
  promptHeight: false,
  promptHint: false,
  typeFirst: true
}
export const SCHEMA_NAME_VALIDATION_MESSAGE =
  'Use letters, numbers, and hyphens, starting with a lowercase letter.'
export const ADD_FIELD_CONFIRM_INITIAL_VALUE = true
export const VERCEL_NEON_URL = 'https://vercel.com/dashboard/integrations/checkout/neon'
